export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
